exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".change-line[data-v-8bf1636a]{color:#F56C6C}.delete-line[data-v-8bf1636a]{text-decoration:line-through}\n", ""]);

// exports
